<template>
  <div class="modalShares">
    <div style="border-radius:10px;padding:10px;" class="card">
      <img
        @click="closeModalShares()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
      <p>{{ $t("evenement.partager") }}</p>
      <hr />
      <Shares :evenement_id="modalShares.evenementId" />
    </div>
  </div>
</template>

<script>
import Shares from "@/components/event/components/Shares";
export default {
  name: "ModalShare",
  components: {
    Shares
  },
  props: {
    modalShares: Object
  },
  methods: {
    closeModalShares() {
      this.$store.commit("MODAL_SHARES", {
        evenementId: null,
        activeModalShares: false
      });
    }
  }
};
</script>
<style scoped>
.modalShares {
  font-size: 12px;
  margin: 50px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/event/components/ModalShare.vue